import { AnyAction } from 'redux';

import {
    NOTIFICATIONS_RECEIVED,
    NOTIFICATIONS_REQUEST,
    NOTIFICATION_CREATE,
    NOTIFICATION_DELETE,
} from '../actions/notifications-actions';
import { NotificationSetting } from '../models/notification-setting';

export interface NotificationsReducerState {
    notifications: NotificationSetting[];
    requesting: boolean;
}
const initialNotificationsReducerState: NotificationsReducerState = {
    notifications: [],
    requesting: false,
};

export const notificationsReducer = (
    state: NotificationsReducerState = initialNotificationsReducerState,
    action: AnyAction
): NotificationsReducerState => {
    switch (action.type) {
        case NOTIFICATIONS_REQUEST: {
            return {
                ...state,
                requesting: true,
            };
        }

        case NOTIFICATIONS_RECEIVED: {
            return {
                ...state,
                notifications: action['notifications'],
                requesting: false,
            };
        }

        case NOTIFICATION_CREATE: {
            return {
                ...state,
                notifications: [...state.notifications, action['notification']],
                requesting: false,
            };
        }

        case NOTIFICATION_DELETE: {
            return {
                ...state,
                notifications: state.notifications.filter(notification => notification.id !== action['id']),
                requesting: false,
            };
        }

        default: {
            return state;
        }
    }
};
